module.exports = __webpack_public_path__ + "img/bs_silo_3.a5f25cd4.png";